import React from "react"
import { Link } from "gatsby"
import "./BannerWithCard.scss"
import { getImageUrl } from "../../services/Utils"

import MainPageBackground from "../../images/main-page-bg.jpg"
import PlannerBackground from "../../images/planner-bg.png"
import SheltersBackground from "../../images/banner2-bg.jpg"

const BannerWithCard = ({
  text,
  pageName,
  cardTitle,
  cardLink,
  bannerBackgroundImage,
  cardBackgroundImage,
}) => {
  function resolvePicture() {
    if (bannerBackgroundImage) {
      return getImageUrl(bannerBackgroundImage)
    }
    switch (pageName) {
      case "main":
        return MainPageBackground
      case "planner":
        return PlannerBackground
      default:
        return SheltersBackground
    }
  }

  function resolveCardBackground() {
    if (cardBackgroundImage) {
      return getImageUrl(cardBackgroundImage)
    }
    return null
  }

  const cardBgUrl = resolveCardBackground()
  const cardStyle = cardBgUrl
    ? {
        background: `url(${cardBgUrl}) no-repeat center center`,
        backgroundSize: "cover",
      }
    : {}

  return (
    <div className="hero-with-card row">
      <div className="col-md-9 hero-with-card__image-col">
        <div
          className="hero-block d-flex align-items-center"
          style={{
            background: `url(${resolvePicture()}) no-repeat center center`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        >
          <div className="col hero-block__content-wrapper">
            <div
              className="hero-text"
              dangerouslySetInnerHTML={{ __html: text }}
            ></div>
          </div>
        </div>
      </div>
      <div className="col-md-3 hero-with-card__card-col">
        <Link
          to={cardLink || "/planner"}
          className={`featured-card${cardBgUrl ? " featured-card--with-bg" : ""}`}
          style={cardStyle}
        >
          {cardTitle && (
            <div
              className="featured-card__title"
              dangerouslySetInnerHTML={{ __html: cardTitle }}
            ></div>
          )}
        </Link>
      </div>
    </div>
  )
}

export default BannerWithCard
